module.exports = __webpack_public_path__ + "img/tilt_2.e17b087e.jpg";